import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread2';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import { forwardRef } from 'react';
import { c as classNames } from '../../../shared/bind-56cf2a3b.js';
import { getTestId } from '../../../utils/testId.js';
import { s as styles } from '../../../shared/Input-a5585d91.js';
import { idFromName } from '../../../utils/html.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var cssClasses = classNames.bind(styles);
var Styling = /*#__PURE__*/function (Styling) {
  Styling["Tight"] = "tight";
  Styling["Narrow"] = "narrow";
  Styling["Wide"] = "wide";
  return Styling;
}(Styling || {});
var Theme = /*#__PURE__*/function (Theme) {
  Theme["Primary"] = "primary";
  return Theme;
}(Theme || {});
var InputSelect = function InputSelect(_ref) {
  var name = _ref.name,
    validation = _ref.validation,
    title = _ref.title,
    value = _ref.value,
    placeholder = _ref.placeholder,
    options = _ref.options,
    styling = _ref.styling,
    theme = _ref.theme,
    forwardedRef = _ref.forwardedRef,
    testId = _ref.testId,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    aria = _ref.aria;
  var renderOptions = function renderOptions() {
    return _mapInstanceProperty(options).call(options, function (option) {
      return /*#__PURE__*/jsx("option", {
        value: option.value,
        "data-testid": getTestId(testId, 'option'),
        children: option.label
      }, option.value);
    });
  };
  var inputClass = cssClasses(styles.input, styles.select, styling, theme);
  var AccessibleWrapper = title ? 'label' : 'div';
  return /*#__PURE__*/jsxs(AccessibleWrapper, {
    htmlFor: name,
    className: inputClass,
    "data-testid": testId,
    children: [title ? /*#__PURE__*/jsx("div", {
      className: styles.title,
      "data-testid": getTestId(testId, 'title'),
      children: title
    }) : null, /*#__PURE__*/jsx("div", {
      className: styles.content,
      children: /*#__PURE__*/jsxs("select", _objectSpread(_objectSpread({
        className: styles.value,
        name: name,
        value: value === null ? undefined : value,
        id: idFromName(name),
        required: required,
        disabled: disabled,
        onChange: onChange,
        onBlur: onBlur,
        ref: forwardedRef,
        "data-testid": getTestId(testId, 'select')
      }, aria), {}, {
        children: [placeholder ? /*#__PURE__*/jsx("option", {
          value: "",
          disabled: true,
          className: styles.placeholder,
          "data-testid": getTestId(testId, 'placeholder'),
          children: placeholder
        }) : null, renderOptions()]
      }))
    }), validation ? /*#__PURE__*/jsx("div", {
      className: styles.note,
      children: validation
    }) : null]
  });
};
// BUG: default exports do not auto-generate storybook ArgsTable
// https://github.com/storybookjs/storybook/issues/9511
// remove export when resolved
var InputTextareaWithForwardedRef = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/jsx(InputSelect, _objectSpread({
    forwardedRef: ref
  }, props));
});
InputTextareaWithForwardedRef.displayName = InputSelect.name;
InputTextareaWithForwardedRef.Styling = Styling;
InputTextareaWithForwardedRef.Theme = Theme;

export { InputTextareaWithForwardedRef, InputTextareaWithForwardedRef as default };
//# sourceMappingURL=InputSelect.js.map
